export default __webpack_public_path__ + "static/media/number-1.c580072d.svg";